import moment from "moment";
import { useEffect, useState } from "react";
import { API_URL, REACT_APP_SITE_KEY } from "../../config/app-config";
import calendar from "../../img/calendar.png";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { FiArrowRight, FiDownload, FiLock, FiCalendar, FiClock, FiZap } from "react-icons/fi";
import { FaStar, FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaGlobe } from "react-icons/fa";

import "./ServiceCardThemeV4.css";

moment.locale("en");

// Calendar Component
function MonthGridCalendar({ slots, packageDays, selectedValue, onSelect }) {
  const today = moment().locale("en");
  const [viewMonth, setViewMonth] = useState(today.clone().startOf("month"));

  const availableSet = new Set((slots || []).filter((s) => s.available).map((s) => s.value));
  const slotMap = {};
  (slots || []).forEach((s) => { slotMap[s.value] = s; });

  const goMonth = (dir) => setViewMonth((prev) => prev.clone().locale("en").add(dir, "month").startOf("month"));

  const vmEn = viewMonth.clone().locale("en");
  const startDay = vmEn.clone().startOf("month").day();
  const daysInMonth = vmEn.daysInMonth();

  const cells = [];
  for (let i = 0; i < startDay; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);

  const weeks = [];
  for (let i = 0; i < cells.length; i += 7) weeks.push(cells.slice(i, i + 7));

  const DOW = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
  const isPrevDisabled = viewMonth.clone().locale("en").isSameOrBefore(today.clone().startOf("month"));

  return (
    <div>
      <div className="monthNavRow" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
        <button type="button" onClick={() => goMonth(-1)} disabled={isPrevDisabled} style={{ background: 'none', border: 'none', cursor: isPrevDisabled ? 'not-allowed' : 'pointer', fontSize: '18px', color: 'var(--tpl-dark)' }}>‹</button>
        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.1em' }}>{vmEn.format("MMMM YYYY")}</h4>
        <button type="button" onClick={() => goMonth(1)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', color: 'var(--tpl-dark)' }}>›</button>
      </div>
      <table className="monthGridCalendar" style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
        <thead>
          <tr>{DOW.map((d) => (<th key={d} style={{ padding: '8px 0', fontSize: '12px', opacity: 0.7 }}>{d}</th>))}</tr>
        </thead>
        <tbody>
          {weeks.map((week, wi) => (
            <tr key={wi}>
              {week.map((day, di) => {
                if (!day) return <td key={di}><div style={{ padding: '8px' }}></div></td>;
                const dateVal = vmEn.clone().date(day).format("YYYY/MM/DD");
                const isPast = vmEn.clone().date(day).isBefore(today, "day");
                const dayMatches = packageDays.length === 0 || packageDays.includes(moment(dateVal, "YYYY/MM/DD").locale("en").format("ddd").toUpperCase());
                const isAvail = availableSet.has(dateVal) && !isPast && dayMatches;
                const isSelected = selectedValue === dateVal;

                let btnClass = "gridDayBtn ";
                if(isSelected) btnClass += "gridSelected";
                else if(isAvail) btnClass += "gridAvailable";

                return (
                  <td key={di} style={{ padding: '4px' }}>
                    <button
                      type="button"
                      className={btnClass}
                      style={{ width: '36px', height: '36px', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto', cursor: isAvail ? 'pointer' : 'not-allowed', opacity: isAvail || isSelected ? 1 : 0.3 }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (!isAvail) return;
                        const slotObj = slotMap[dateVal];
                        if (slotObj) onSelect(slotObj);
                      }}
                    >
                      {day}
                    </button>
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Time Panel Component
function TimeSidePanel({ hasDateSelected, slots, selectedSlot, onSelect, isDisabledFn }) {
  return (
    <div className="mira-timeSide">
      <div className="panelLabel" style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '16px', fontWeight: 700 }}>
        Select Time
      </div>
      {!hasDateSelected ? (
        <div style={{ opacity: 0.5, fontSize: '13px' }}>Pick a date to see times</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
          {slots.length > 0 ? (
            slots.map((item, i) => {
              const fromStr = item.from ?? "";
              const toStr = item.to ?? "";
              const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
              const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
              const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
              const isSelected = selectedSlot?.from === fromStr && selectedSlot?.to === toStr;
              const isDisabled = isDisabledFn ? isDisabledFn(item) : false;

              return (
                <button
                  type="button"
                  key={i}
                  className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                  style={{ padding: '10px', fontSize: '12px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                  onClick={(e) => { e.preventDefault(); if (!isDisabled) onSelect(item); }}
                >
                  {displayFrom} – {displayTo}
                </button>
              );
            })
          ) : (
            <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7 }}>No slots available</p>
          )}
        </div>
      )}
    </div>
  );
}

// Main Component
const ServiceCardThemeV4 = ({
  data,
  selectService,
  isPreview,
  uploadDetails,
  updateState,
  confirmDetails,
  recaptcha,
  viewAvailableSlot,
  slugSelected,
  onResourceClick,
}) => {

  const eventData = data.eventData || data.eventDetails || {};
  const userDetails = data.userDetails || {};
  const resourceList = data.resource || data.resourceList || [];

  const businessLogo = isPreview
    ? eventData.businessLogo
    : eventData.businessLogo ? `${API_URL}auth/image/${eventData.businessLogo}` : calendar;

  const businessName = eventData.businessName || userDetails.userName || "Mira Rao";
  const displayTitle = eventData.serviceName || "Come back to your own centre.";

  // Social Media Extractor
  const { faceBook, instagram, linkedIn, youtube, personalWebsite } = userDetails;
  const hasSocials = faceBook || instagram || linkedIn || youtube || personalWebsite;

  // --- REVIEW RANKING & FALLBACK LOGIC ---
  const fallbackQuotes = [
    "Her sessions are the one appointment I protect every week.",
    "Her cues are specific without ever feeling demanding.",
    "A transformative space for both mind and body.",
    "I left with a clearer head and a grounded presence.",
    "The most intentional and restorative practice I've had in years."
  ];

  const rawReviews = data.reviewList || [];

  const sortedReviews = [...rawReviews].sort((a, b) => {
    if ((b.satisfaction || 0) !== (a.satisfaction || 0)) {
      return (b.satisfaction || 0) - (a.satisfaction || 0);
    }
    return (b.updateDate || 0) - (a.updateDate || 0);
  });

  const reviews = sortedReviews.length > 0
    ? sortedReviews.map((rev, i) => {
        const isNotGiven = !rev.suggestion || rev.suggestion === "Not given" || rev.suggestion.trim() === "";
        return {
          ...rev,
          displaySuggestion: isNotGiven ? fallbackQuotes[i % fallbackQuotes.length] : rev.suggestion,
          displayName: rev.name || "Client",
          displaySource: rev.source || (rev.type === "review" ? "Client Review" : "Google")
        };
      })
    : [
        { displayName: "Devika M.", displaySource: "Google", displaySuggestion: fallbackQuotes[0], satisfaction: 5, updateDate: Date.now() - 86400000 },
        { displayName: "Leela S.", displaySource: "Google", displaySuggestion: fallbackQuotes[1], satisfaction: 5, updateDate: Date.now() },
      ];

  const avgRating = eventData.ratings ?? "4.9";
  const totalReviewsCount = eventData.reviewCount || reviews.length;

  const [reviewIndex, setReviewIndex] = useState(0);

  const bannerReview = reviews.length > 1 ? reviews[1] : reviews[0];
  const boxReview = reviews[reviewIndex] || reviews[0];

  const dummyServices = [
    {
      serviceName: "Restorative reset",
      duration: 60,
      amount: 1800,
      appointmentLocation: "Private online",
      appointmentName: "INDIVIDUAL SESSION",
      description: "A personal practice shaped around your energy and experience.",
      btnText: "Book this session →"
    },
    {
      serviceName: "Breath & balance",
      duration: 75,
      amount: 2200,
      appointmentLocation: "In studio",
      appointmentName: "INDIVIDUAL SESSION",
      description: "A focused guided session with room for questions and adjustments.",
      btnText: "Book this session →"
    },
    {
      serviceName: "Sunday unwind",
      duration: 90,
      amount: 2800,
      appointmentLocation: "Small group",
      appointmentName: "SMALL GROUP CLASS",
      description: "A shared practice with a deliberately limited number of mats.",
      btnText: "Book this class →"
    }
  ];

  const rawServiceList = data.service || data.serviceList || [];
  const serviceList = rawServiceList.length > 0 ? rawServiceList : dummyServices;

  // States
  const [chosenService, setChosenService] = useState(null);
  const [isPackageSelected, setIsPackageSelected] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedNoteOption, setSelectedNoteOption] = useState(""); // Track the dropdown selection
  const isMobile = window.screen.width < 768;

  // Auto-select from slug
  useEffect(() => {
    if (!slugSelected || !serviceList.length) return;
    const index = serviceList.findIndex((s) => s.slug === slugSelected || String(s.id) === String(slugSelected));
    if (index !== -1) {
      handleBookClick(serviceList[index], index);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slugSelected, serviceList]);

  // FIX 2: close the modal automatically once a booking completes
  // (free flow doesn't redirect immediately, so isModalOpen was never
  // reset — parent flips data.bookingSuccess on both free & paid success)
  useEffect(() => {
    if (data.bookingSuccess) {
      setIsModalOpen(false);
    }
  }, [data.bookingSuccess]);

  const safeParse = (value) => {
    try {
      if (!value) return [];
      const p = JSON.parse(value);
      return typeof p === "string" ? JSON.parse(p) : p;
    } catch (e) {
      return [];
    }
  };

  const packageDays = safeParse(isPackageSelected?.packageDays);
  const timeSlots = safeParse(isPackageSelected?.timeSlots) || [];

  const getAllSlots = () => {
    if (!data.availableSlot?.length) return [];
    return data.availableSlot.filter((item) => {
      if (Object.keys(data?.activeIndexData || {}).length > 0) {
        const isToday = moment(data.activeIndexData.value, "YYYY/MM/DD");
        if (isToday.isSame(moment(), "day")) {
          const curTime = moment(new Date(), "HH:mm");
          const fromTime = moment(item.from, "HH:mm");
          return fromTime.isSameOrAfter(curTime);
        }
      }
      return true;
    });
  };

  const priceLabel = (svc) => (svc?.amount == 0 ? "Free" : `₹${svc?.amount}`);
  const selectedServiceObj = chosenService !== null ? serviceList[chosenService] : null;

  const handleBookClick = (item, ind) => {
    selectService(item);
    setChosenService(ind);
    setIsPackageSelected(item);
    updateState("bookingMode", "self");
    updateState("expertNote", "");
    updateState("bookingSuccess", false); // FIX 2: reset any stale success flag from a prior booking
    setIsModalOpen(true);
  };

  const handleResourceCardClick = (res) => {
    if (isPreview) return;
    if (typeof onResourceClick === "function") onResourceClick(res);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    updateState("name", "");
    updateState("email", "");
    updateState("phoneNumber", "");
    updateState("description", "");
    updateState("detailsPage", false); // Reset back to step 1
    updateState("bookingSuccess", false); // FIX 2: keep state clean on manual close too
    setSelectedNoteOption(""); // Reset dropdown selection

    // Reset recaptcha if it exists
    if (recaptcha?.current) {
      recaptcha.current.reset();
    }
  };

  const handleNextReview = () => setReviewIndex((prev) => (prev + 1) % reviews.length);
  const handlePrevReview = () => setReviewIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  const renderStepper = (activeStep) => (
    <div className="mira-bkStepBar">
      <div className={`mira-bkStep ${activeStep === 1 ? "active" : activeStep > 1 ? "done" : ""}`}>
        <div className="mira-bkStepCircle">{activeStep > 1 ? "✓" : "1"}</div>
        <span>Choose option</span>
      </div>
      <div className={`mira-bkStepLine ${activeStep > 1 ? "done" : ""}`} />
      <div className={`mira-bkStep ${activeStep === 2 ? "active" : activeStep > 2 ? "done" : ""}`}>
        <div className="mira-bkStepCircle">{activeStep > 2 ? "✓" : "2"}</div>
        <span>Provide details</span>
      </div>
      <div className={`mira-bkStepLine ${activeStep > 2 ? "done" : ""}`} />
      <div className={`mira-bkStep ${activeStep === 3 ? "active" : ""}`}>
        <div className="mira-bkStepCircle">3</div>
        <span>Confirmation</span>
      </div>
    </div>
  );

  const renderBookingModal = () => {
    if (!isModalOpen || chosenService === null) return null;
    const isGroupPackage = ["group_package", "one_to_one_package"].includes(isPackageSelected?.appointmentName);

    return (
      <div className="mira-modal-overlay" onClick={closeModal}>
        <div className="mira-modal-content" onClick={(e) => e.stopPropagation()}>
          <button type="button" className="mira-modal-close" onClick={closeModal}>×</button>

          {data.detailsPage ? (
            <form onSubmit={(e) => { e.preventDefault(); uploadDetails(e); }} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              {renderStepper(2)}
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '16px' }}>
                <h4 className="mira-service-meta" style={{ margin: 0, fontSize: '18px' }}>Provide Details</h4>
                <button type="button" onClick={() => { recaptcha?.current?.reset(); updateState("detailsPage", false); }} className="mira-btn-outline" style={{ padding: '6px 12px', border: 'none' }}>
                  ← Back to Options
                </button>
              </div>

              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Name *</label>
                <input className="input-text-input" value={data.name} type="text" placeholder="Enter name" required onChange={(e) => updateState("name", e.target.value)} />
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Email *</label>
                <input className="input-text-input" value={data.email} type="email" placeholder="Enter email" required onChange={(e) => updateState("email", e.target.value?.trim())} />
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Phone Number *</label>
                <div style={{ marginTop: "4px" }}>
                  <PhoneInput
                    country={"in"}
                    containerClass="input-dark"
                    value={data.phoneNumber}
                    placeholder=""
                    countryCodeEditable={false}
                    onChange={(phone) => updateState("phoneNumber", phone)}
                    required
                  />
                </div>
              </div>
              <div>
                <label style={{ display:'block', marginBottom:'8px', fontSize:'13px', fontWeight:600 }}>Notes for preparation *</label>
                <select
                  className="input-text-input"
                  value={selectedNoteOption}
                  required
                  onChange={(e) => {
                    setSelectedNoteOption(e.target.value);
                    if (e.target.value !== "Other") {
                      updateState("description", e.target.value);
                    } else {
                      updateState("description", "");
                    }
                  }}
                  style={{ marginBottom: selectedNoteOption === "Other" ? '12px' : '0' }}
                >
                  <option value="" disabled>Select an option</option>
                  <option value="I'm looking for general relaxation and mindfulness.">I'm looking for general relaxation and mindfulness.</option>
                  <option value="I'm dealing with specific tension/tightness and need relief.">I'm dealing with specific tension/tightness and need relief.</option>
                  <option value="I'm a beginner looking for a gentle introduction.">I'm a beginner looking for a gentle introduction.</option>
                  <option value="Other">Other (I will type my own notes)</option>
                </select>

                {selectedNoteOption === "Other" && (
                  <textarea
                    className="input-text-input"
                    value={data.description}
                    required={selectedNoteOption === "Other"}
                    placeholder="Please specify your requirements or notes here..."
                    onChange={(e) => updateState("description", e.target.value)}
                    style={{ minHeight: '100px', resize: 'vertical' }}
                  />
                )}
              </div>

              <div style={{ margin: "8px 0" }}>
                <ReCAPTCHA size={isMobile ? "compact" : "normal"} ref={recaptcha} sitekey={REACT_APP_SITE_KEY} />
              </div>

              <button type="submit" className="scheduleBt" onClick={() => confirmDetails()} style={{ alignSelf: 'flex-start' }}>
                <FiCalendar size={16}/> Book {selectedServiceObj?.serviceName} - {priceLabel(selectedServiceObj)} <FiArrowRight size={16} />
              </button>
            </form>
          ) : (
            <div>
              {renderStepper(1)}

              {!isGroupPackage && (
                <>
                  <div style={{ marginBottom: '24px' }}>
                    <h2 className="mira-service-title" style={{ fontSize: '28px', marginBottom: '8px' }}>
                      <FiCalendar size={24} style={{ marginRight: '8px', verticalAlign: 'bottom' }}/>
                      Schedule your session
                    </h2>
                    <p style={{ opacity: 0.8 }}>Choose how you'd like to book</p>
                  </div>

                  <div className="mira-bkModeRow">
                    <div className={`mira-bkModeCard ${data.bookingMode === "self" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "self")}>
                      <div className="mira-bkModeRadio">{data.bookingMode === "self" && <div className="mira-bkModeRadioInner" />}</div>
                      <div className="mira-bkModeText">
                        <h5>I'll pick date & time</h5>
                        <p>Select from available slots</p>
                      </div>
                    </div>

                    <div className={`mira-bkModeCard ${data.bookingMode === "expert" ? "bkSelected" : ""}`} onClick={() => updateState("bookingMode", "expert")}>
                      <div className="mira-bkModeRadio">{data.bookingMode === "expert" && <div className="mira-bkModeRadioInner" />}</div>
                      <div className="mira-bkModeText">
                        <h5>Let the expert choose</h5>
                        <p>Share your preference and expert will schedule</p>
                      </div>
                    </div>
                  </div>
                </>
              )}

              {data.bookingMode === "expert" && !isGroupPackage && (
                <div style={{ padding: '24px', background: 'rgba(27, 56, 45, 0.03)', border: '1px solid var(--tpl-border)', borderRadius: '4px', marginBottom: '24px' }}>
                  <label style={{ display:'block', marginBottom:'12px', fontSize:'14px', fontWeight:700 }}>Share your preference / availability</label>
                  <textarea
                    className="input-text-input"
                    placeholder="e.g. I'm available weekday evenings after 6 PM IST, prefer Thursday or Friday..."
                    value={data.expertNote || ""}
                    onChange={(e) => updateState("expertNote", e.target.value)}
                    style={{ minHeight: '100px', marginBottom: '12px' }}
                  />
                  <p style={{ fontSize: '12px', opacity: 0.7 }}>The expert will review your preference and send you a confirmed slot via email.</p>
                </div>
              )}

              {(data.bookingMode === "self" || isGroupPackage) && (
                <div className="mira-calTimeSplit">
                  <div className="mira-calSide">
                    <div className="mira-service-meta" style={{ marginBottom: '16px' }}><FiCalendar size={13} style={{ marginRight:'4px' }}/> Select Date</div>
                    <MonthGridCalendar
                      slots={data.slots}
                      packageDays={isGroupPackage ? packageDays : []}
                      selectedValue={data.activeIndexData?.value}
                      onSelect={(slotObj) => {
                        const idx = data.slots?.findIndex((s) => s.value === slotObj.value);
                        viewAvailableSlot(idx ?? 0, slotObj, slotObj.available);
                      }}
                    />
                  </div>

                  <div className="mira-timeSide">
                    <div className="mira-service-meta" style={{ marginBottom: '16px' }}><FiClock size={13} style={{ marginRight:'4px' }}/> Available Time Slots</div>

                    {data.activeIndexData?.value && (
                      <div className="mira-tzChip">
                        <FiClock size={11} /> {eventData.timeZone ? `All times shown in ${eventData.timeZone}` : "All times shown in IST"}
                      </div>
                    )}

                    {!data.activeIndexData?.value ? (
                      <div style={{ padding: '40px 20px', textAlign: 'center', opacity: 0.5, border: '1px dashed var(--tpl-border)', borderRadius: '8px' }}>
                        <FiCalendar size={32} style={{ marginBottom: '12px' }} />
                        <p style={{ fontSize: '13px' }}><strong>No date selected</strong><br/>Pick a date on the left to see available time slots</p>
                      </div>
                    ) : (
                      <div className="mira-twoColSlots">
                        {(isGroupPackage ? timeSlots : getAllSlots()).length > 0 ? (
                          (isGroupPackage ? timeSlots : getAllSlots()).map((item, i) => {
                            const fromStr = item.from ?? "";
                            const toStr = item.to ?? "";
                            const fmt = fromStr.includes("AM") || fromStr.includes("PM") ? "hh:mm A" : "HH:mm";
                            const displayFrom = moment(fromStr, fmt).isValid() ? moment(fromStr, fmt).format("h:mm A") : fromStr;
                            const displayTo = moment(toStr, fmt).isValid() ? moment(toStr, fmt).format("h:mm A") : toStr;
                            const isSelected = data.selectedSlot?.from === fromStr && data.selectedSlot?.to === toStr;
                            const isDisabled = item.slotAvailable === false;

                            return (
                              <button
                                type="button"
                                key={i}
                                className={`timeSlotBtn ${isSelected ? 'tsActive' : ''}`}
                                style={{ padding: '10px', fontSize: '12px', cursor: isDisabled ? 'not-allowed' : 'pointer', opacity: isDisabled ? 0.5 : 1 }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  if (!isDisabled) {
                                    updateState("slotActiveIndex", isGroupPackage ? i : getAllSlots().findIndex(s => s.from === item.from));
                                    updateState("selectedSlot", item);
                                  }
                                }}
                              >
                                {displayFrom} – {displayTo}
                              </button>
                            );
                          })
                        ) : (
                          <p style={{ gridColumn: '1/-1', fontSize: '13px', opacity: 0.7 }}>No slots available for this date</p>
                        )}
                      </div>
                    )}

                    {!isGroupPackage && data.activeIndexData?.value && (
                       <div className="mira-sp-confirm-box">
                         <FiZap size={18} color="var(--tpl-dark)" style={{ flexShrink: 0, marginTop: "2px" }} />
                         <div>
                           <h6>Instant confirmation</h6>
                           <p>Your session will be confirmed immediately after booking.</p>
                         </div>
                       </div>
                    )}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '32px', display: 'flex', justifyContent: 'center' }}>
                <button
                   type="button"
                   className="scheduleBt"
                   style={{ width: '100%', maxWidth: '400px' }}
                   onClick={() => isPreview ? () => {} : confirmDetails()}
                >
                  Continue to Details <FiArrowRight size={16} />
                </button>
              </div>

            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="mira-wrapper">
      <div className="mira-container">

        {/* Navigation */}
        <header className="mira-header">
          <div className="mira-logo-group">
            {businessLogo && (
               <span className="mira-logo-circle">
                 <img src={businessLogo} alt="Logo" />
               </span>
            )}
            <span><em>{businessName.toUpperCase()} {eventData.serviceName ? `/ ${eventData.serviceName.toUpperCase()}` : '/ STILL'}</em></span>
          </div>
          <div>{eventData.timeZone ? "ONLINE + " + eventData.timeZone.split('/')[1]?.replace(/_/g, ' ').toUpperCase() : "ONLINE + BANDRA"}</div>
        </header>

        {/* Hero Area */}
        <section className="mira-hero">
          <div className="mira-hero-content">
            <div className="mira-hero-eyebrow">{eventData.sliderTextTwo || "Slow, steady practice"}</div>

            <h1 className="mira-hero-title">
              {eventData.sliderTextOne || displayTitle}
            </h1>

            <div className="mira-hero-desc" dangerouslySetInnerHTML={{__html: eventData.description || "Mira Rao holds small, attentive yoga sessions for bodies asking for more room to breathe." }} />

            {/* FIX 1: scrollIntoView instead of offsetTop-based scrollTo — offsetTop
                is relative to the nearest positioned ancestor, not the page, so with
                a positioned ancestor in the tree (e.g. modal overlay) it silently
                resolves to 0 or the wrong offset. scrollIntoView always targets the
                real element regardless of ancestor positioning. */}
            <button
              type="button"
              className="mira-btn-primary"
              onClick={() =>
                document
                  .querySelector('.mira-services-wrapper')
                  ?.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            >
              Book a practice
            </button>

            {/* Render Social Media Links if Present */}
            {hasSocials && (
              <div className="mira-social-links">
                {personalWebsite && <a href={personalWebsite} target="_blank" rel="noreferrer" className="mira-social-icon"><FaGlobe /></a>}
                {faceBook && <a href={faceBook} target="_blank" rel="noreferrer" className="mira-social-icon"><FaFacebookF /></a>}
                {instagram && <a href={instagram} target="_blank" rel="noreferrer" className="mira-social-icon"><FaInstagram /></a>}
                {linkedIn && <a href={linkedIn} target="_blank" rel="noreferrer" className="mira-social-icon"><FaLinkedinIn /></a>}
                {youtube && <a href={youtube} target="_blank" rel="noreferrer" className="mira-social-icon"><FaYoutube /></a>}
              </div>
            )}
          </div>

          <div className="mira-hero-visual">
            <div className="mira-circle-bg"></div>
            {businessLogo ? (
               <div className="mira-hero-image" style={{ backgroundImage: `url(${businessLogo})` }}></div>
            ) : (
               <div className="mira-hero-image" style={{ background: 'var(--tpl-accent)', color: '#fff' }}>
                 {businessName.charAt(0).toUpperCase()}
               </div>
            )}
          </div>
        </section>

        {/* Services Section Wrapper */}
        <div className="mira-services-wrapper" id="services-section">
          <div className="mira-services-grid">
            {serviceList.map((item, ind) => {
              const active = chosenService === ind;
              return (
                <div key={ind} className={`mira-service-card ${active ? 'active' : ''}`}>
                  <div className="mira-service-meta">
                    0{ind + 1} - {item.duration} MIN
                  </div>
                  <h3 className="mira-service-title">{item.serviceName}</h3>
                  <div className="mira-service-price">
                    {priceLabel(item)} {item.appointmentLocation ? `· ${item.appointmentLocation}` : ''}
                  </div>
                  <div className="mira-service-type">
                    {item.appointmentName?.replace(/_/g, ' ').toUpperCase() || "INDIVIDUAL SESSION"}
                  </div>
                  <div className="mira-service-desc" dangerouslySetInnerHTML={{__html: item.description}} />
                  <button type="button" className="mira-btn-outline" onClick={() => handleBookClick(item, ind)}>
                    {item.btnText || "Book this session →"}
                  </button>
                </div>
              );
            })}
          </div>
        </div>

        {/* Testimonial Banner Section */}
        {reviews.length > 0 && (
          <section className="mira-testimonial-banner">
            <div className="mira-banner-quote">
              <div style={{color: 'var(--tpl-dark)', letterSpacing: '2px', fontSize: '14px', marginBottom: '16px'}}>★★★★★</div>
              “{bannerReview?.displaySuggestion}”
              <span>— {bannerReview?.displayName} · {bannerReview?.displaySource}</span>
            </div>
            <div className="mira-banner-stats">
              <h4>{avgRating}/5 FROM {totalReviewsCount} REVIEWS</h4>
              <p>Selected notes from {businessName.split(' ')[0]}'s clients.</p>
            </div>
          </section>
        )}

        {/* Resources Section */}
        {resourceList.length > 0 && (
          <section className="mira-section" id="resources-section">
            <div className="mira-section-header">
              <div className="mira-hero-eyebrow" style={{ marginBottom: '8px' }}>Ready-made resources</div>
              <h2 className="mira-service-title" style={{ fontSize: '28px', border: 'none', margin: 0 }}>Get instant access</h2>
            </div>
            <div className="mira-services-grid">
              {resourceList.map((res, ind) => {
                const isResourceFree = Number(res.amount) === 0;
                const fileCount = res.resourceFiles?.length || 0;

                return (
                  <div key={res.id} className="mira-service-card" onClick={() => handleResourceCardClick(res)} style={{ cursor: 'pointer' }}>
                    <div className="mira-service-meta">
                      RESOURCE {ind + 1} {fileCount > 0 && `· ${fileCount} FILE${fileCount !== 1 ? 'S' : ''}`}
                    </div>
                    <h3 className="mira-service-title">{res.serviceName}</h3>
                    <div className="mira-service-price">
                      {isResourceFree ? "Free" : `₹${res.amount}`}
                    </div>
                    <div className="mira-service-desc" dangerouslySetInnerHTML={{__html: res.description}} />
                    <button
                      type="button"
                      className="mira-btn-outline"
                      onClick={(e) => { e.stopPropagation(); handleResourceCardClick(res); }}
                    >
                      {isResourceFree ? (
                        <>Get this resource <FiDownload size={14} /></>
                      ) : (
                        <>Buy now <FiLock size={12} /></>
                      )}
                    </button>
                  </div>
                );
              })}
            </div>
          </section>
        )}

        {/* Client Notes Slider Section */}
        {reviews.length > 0 && (
          <section className="mira-notes-section">
            <div className="mira-notes-box">
              <div className="mira-notes-header">
                <div>
                  <h4>Client notes</h4>
                  <h2>What clients say about {businessName}</h2>
                </div>
                <div style={{ fontSize: '13px', fontWeight: 500 }}>★★★★★ · {avgRating}/5</div>
              </div>

              <div className="mira-notes-content">
                <blockquote>
                  “{boxReview?.displaySuggestion}”
                </blockquote>

                <div style={{ fontSize: '13px', marginBottom: '48px', opacity: 0.8, display: 'flex', alignItems: 'center' }}>
                  {Array.from({ length: Math.round(boxReview?.satisfaction || 5) }).map((_, i) => (
                     <FaStar key={i} size={12} color="#1b382d" style={{ marginRight: '2px' }} />
                  ))}
                  &nbsp;· {boxReview?.displayName} · {boxReview?.displaySource}
                  {boxReview?.updateDate && ` · ${moment(boxReview.updateDate).format("MMM YYYY")}`}
                </div>

                <div className="mira-notes-controls">
                  <div>
                    <button type="button" className="mira-arrow-btn" onClick={handlePrevReview}>←</button>
                    <button type="button" className="mira-arrow-btn" onClick={handleNextReview}>→</button>
                  </div>
                  <div style={{ fontSize: '12px', opacity: 0.6, letterSpacing: '0.1em' }}>
                    {reviews.length > 0 ? `${reviewIndex + 1} / ${reviews.length}` : "0 / 0"}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Divider above provider */}
        <hr className="mira-provider-divider" />

        {/* About Provider */}
        <section className="mira-about-section">
          <h4>Meet your provider</h4>
          <h3>{businessName}</h3>
          <p>{userDetails.profession?.professionName || "A restorative yoga teacher who keeps practice simple, spacious and grounded in the body."}</p>

          {eventData.specialisations && (
            <div className="mira-tag-container" style={{ marginTop: '24px' }}>
               {eventData.specialisations.split(',').map((spec, i) => (
                  <span key={i} className="mira-tag">{spec.trim()}</span>
               ))}
            </div>
          )}

          {/* Yuukke Logo Re-creation for Footer */}
          <div className="mira-yuukke-footer">
            <svg width="120" height="30" viewBox="0 0 120 30" fill="none" xmlns="http://www.w3.org/2000/svg">
               <path d="M12.5 5 C10 12 15 20 18 20 C18 10 15 5 12.5 5 Z" fill="#e91e63" />
               <path d="M22 5 C24.5 12 19 20 16 20 C16 10 19 5 22 5 Z" fill="#e91e63" opacity="0.8" />
               <text x="32" y="21" fontFamily="Inter" fontWeight="600" fontSize="18" fill="#1b382d">Yuukke</text>
            </svg>
          </div>
        </section>

        {/* Render Modal last so it overlays everything */}
        {renderBookingModal()}
      </div>
    </div>
  );
};

export default ServiceCardThemeV4;